import banner from "../img/banner.png";

const BannerLogos = () => {
  return (
    <footer className="banner w-100 fondo-blanco">
      <img
        src={banner}
        alt="Banner de entidades que subvencionan el proyecto."
      />
    </footer>
  );
};

export default BannerLogos;
